/** @format */

import React from "react";
import { Switch } from "react-router-dom";

import { ROUTES } from "./routes.constant";
import { Login } from "../container/auth";
import Dashboard from "../container/dashborad";
import PublicRoute from "./public.route";
// import PrivateRoute from "./private.route";
import CreateUser from "../container/dashborad/createUser";
import EditUser from "../container/dashborad/editUser";
// import ManageUser from "../container/dashborad/manageUser";

const Routes = () => {
  return (
    <Switch>
      <PublicRoute
        restricted={false}
        exact
        path={ROUTES.LOGIN}
        component={Login}
      />

      <PublicRoute component={Dashboard} path={ROUTES.DASHBOARD} />
      <PublicRoute component={CreateUser} path={ROUTES.CREATE_USER} />
      <PublicRoute component={EditUser} path={ROUTES.EDIT_USER} />
      {/* <PublicRoute component={ManageUser} path={ROUTES.MANAGE_USER} /> */}
      
    </Switch>
  );
};
export { Routes, ROUTES };
